module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/players-table/players-table.component.css
// module id = ./src/app/players-table/players-table.component.css
// module chunks = main